import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

import { TabsContent, TabsIndicator, TabsList, TabsRoot, TabsTrigger } from 'reka-ui';
    import { cn } from '@/lib/utils';
    import type { Tab } from '@/types';

    interface Props {
        tabs: Tab[];
        defaultTab?: string;
        containerClass?: string;
        tabListClass?: string;
        tabTriggerClass?: string;
        tabContentClass?: string;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
    tabs: {},
    defaultTab: { default: '' },
    containerClass: {},
    tabListClass: {},
    tabTriggerClass: {},
    tabContentClass: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TabsRoot), {
    class: _normalizeClass(_unref(cn)('flex w-full flex-col', _ctx.containerClass)),
    "default-value": _ctx.defaultTab || _ctx.tabs[0]?.value
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(TabsList), {
        class: _normalizeClass(
                _unref(cn)(
                    'no-scrollbar sticky top-0 z-20 mb-5 flex shrink-0 gap-5 overflow-x-auto overflow-y-hidden border-b bg-white',
                    _ctx.tabListClass,
                )
            )
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TabsIndicator), { class: "bg-primary absolute bottom-0 left-0 h-[2px] w-[var(--reka-tabs-indicator-size)] translate-x-[var(--reka-tabs-indicator-position)] rounded-full transition-[width,transform,translate] duration-300" }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
            return (_openBlock(), _createBlock(_unref(TabsTrigger), {
              key: tab.value,
              value: tab.value,
              class: _normalizeClass(
                    _unref(cn)(
                        'text-primary/50 hover:text-primary data-[state=active]:text-primary flex cursor-pointer items-center justify-center py-3 text-xs leading-none whitespace-nowrap outline-none select-none focus-visible:relative focus-visible:shadow-[0_0_0_2px] focus-visible:shadow-black',
                        _ctx.tabTriggerClass,
                    )
                )
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(tab.label)), 1)
              ]),
              _: 2
            }, 1032, ["value", "class"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["class"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createBlock(_unref(TabsContent), {
          key: tab.value,
          value: tab.value,
          class: _normalizeClass(_unref(cn)('grow outline-none', _ctx.tabContentClass))
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, tab.value)
          ]),
          _: 2
        }, 1032, ["value", "class"]))
      }), 128))
    ]),
    _: 3
  }, 8, ["class", "default-value"]))
}
}

})